import React from "react";

import { Typography, Tag } from "clearsense-ui/components";

const getPredictionColor = prediction => (prediction ? "#ebf4ec" : "#FAEAEA");

const COLUMN_DATA = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    fixed: "left",
    width: 250,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    dataIndex: "prediction",
    key: "prediction",
    title: "Prediction",
    width: 100,
    render: (_, { prediction }) => (
      <Tag
        color={getPredictionColor(prediction)}
        label={prediction?.toString()}
        data-cy="prediction-status-tag"
        className="capitalize"
        size="large"
      />
    ),
  },
  {
    dataIndex: "confidence",
    key: "confidence",
    title: "Confidence",
    width: 100,
    render: (_, { confidence }) => (
      <Typography type="semibold" style="h5">{`${confidence}%`}</Typography>
    ),
    sorter: (a, b) => a.confidence.localeCompare(b.confidence),
  },
  {
    dataIndex: "contributorValues",
    key: "contributorValues",
    title: "Contributor Values",
    width: 400,
    render: (_, { contributorValues }) => (
      <>
        {contributorValues.map((value, i) => (
          <div key={`${value}-${i}`}>
            <Typography type="semibold" style="h5">
              {value}
            </Typography>
          </div>
        ))}
      </>
    ),
  },
];

export { COLUMN_DATA };
